import React, {ReactNode} from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../AdminSidebar/Sidebar";
import SidebarItem from "../AdminSidebar/Props/SidebarItem";

const AdminLayout: React.FC<{children: ReactNode}> = ({children}) => {
    const location = useLocation();
    const isAdminPage = location.pathname.includes("/admin")
    
    if (isAdminPage) {
        return (
            <div className="h-screen flex w-full">  {/* Parent container: Uses flexbox */}
                <div className="sm:block sm:w-[23%] ">
                <Sidebar>
                    <SidebarItem icon={"/assets/StudentB.png"} text="Estudiantes" to="/admin/students" />
                    <SidebarItem icon={"/assets/ColabB.png"} text="Colaboradores" to="/admin/colaborators" />
                    <SidebarItem icon={"/assets/ModuleB.png"} text="Módulos" to="/admin/modules" />
                    <SidebarItem icon={"/assets/paymentB.png"} text="Pagos" to="/admin/payments" />
                </Sidebar>
                </div>
                <div className="w-full flex flex-col bg-gray-100 p-4 overflow-y-auto">
                    <main className="flex-grow">{children}</main>
                </div>
            </div>
        );
    }

    return (
        <main>{children}</main>
    )
}

export default AdminLayout;